import React from 'react';
import PropTypes from 'prop-types';
import BookmarkRecommendation from '../BookmarkRecommendation';
import Swiper from 'react-id-swiper';
import withSizes from 'react-sizes'

class RecommendationsList extends React.Component {
  constructor(props) {
    super(props);
    /*this.preventTouch = this.preventTouch.bind(this);
    this.touchStart = this.touchStart.bind(this);
    this.carouselRef = React.createRef();*/
  }
  
  /*componentDidMount() {
    // Disable touchmove to prevent scrolling entire page
    const carousel = document.getElementsByClassName('myarchdaily-slider')[0]; // Your site element containing react-slick's carousel-container
    console.log(carousel);
    carousel.addEventListener('touchstart', this.touchStart);
    carousel.addEventListener('touchmove', this.preventTouch, { passive: false });
  }
  
  touchStart(e) {
    // capture user's starting finger position, for later comparison
    this.firstClientX = e.touches[0].clientX;
  }
  
  preventTouch(e) {
    // only prevent touch on horizontal scroll (for horizontal carousel)
    // this allows the users to scroll vertically past the carousel when touching the carousel
    // this also stabilizes the horizontal scroll somewhat, decreasing vertical scroll while horizontal scrolling
    const clientX = e.touches[0].clientX - this.firstClientX;
    const horizontalScroll = Math.abs(clientX) > 5;
    if (horizontalScroll) {
      console.log("prevented");
      e.preventDefault();
    }
  }*/
  
  render() {
    let content = <div />;
    if (this.props.items && this.props.items.length > 0) {
      content = this.props.items.map(item => (
        <div key={item.id}><BookmarkRecommendation item={item} /></div>
      ));
    }
  
    if (this.props.items && this.props.items.length > 0) {
      let listItems = content;
      if (this.props.isMobile) {
        const params = {
          slidesPerView: 3,
          freeMode: true,
          spaceBetween: 20,
          loop: true,
          breakpoints: {
            320: {
              slidesPerView: 2,
              spaceBetween: 60,
            },
            480: {
              slidesPerView: 2,
            },
            640: {
              slidesPerView: 3,
            },
          }
        };
        listItems = <Swiper {...params}>{content}</Swiper>;
      }
      return (
        <div className="myarchdaily-recommendations-wrapper myarchdaily-slider slider js_multislides"  data-insights-category="myad-feed" data-insights-label="bookmarks-recommendations" data-insights-value={this.props.listTitle}>
          <h2 className="afd-title-big afd-title-big--bmargin-big">
             <div dangerouslySetInnerHTML={{ __html: this.props.listTitle }} />
          </h2>
          <ul className="afd-search-list myad-desktop-margin myad-bookmark__recommendations-list slides js_slides" ref={this.carouselRef} >
            {listItems}
          </ul>
        </div>
      );
    }
    // if we don't have any elements, we don't render the component
    return <div className="myarchdaily-recommendations-wrapper myarchdaily-slider"/>;
  }
}

RecommendationsList.propTypes = {
  listTitle: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  })),
};

RecommendationsList.defaultProps = {
  items: null,
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 767,
})

export default withSizes(mapSizesToProps)(RecommendationsList);
